import axios from "axios";

//Create User
const createUser = async (user) => {
  const response = await axios.post("/api/v1/user/register", user);
  return response.data.data;
};

// Login User
const loginUser = async (user) => {
  const response = await axios.post("/api/v1/user/login", user);
  return response.data;
};

// Update User
const updateUser = async (userData, id, token) => {
  const response = await axios.patch(`/api/v1/user/${id}`, userData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

// get user by id
const getUserById = async (id, token) => {
  const response = await axios.get(`/api/v1/user/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

// get all users
const getAllUsers = async (token) => {
  const response = await axios.get("/api/v1/user", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

const userService = {
  createUser,
  loginUser,
  updateUser,
  getUserById,
  getAllUsers,
};

export default userService;
